import { render, staticRenderFns } from "./new-supplier-form-edit.vue?vue&type=template&id=48e303da&scoped=true"
import script from "./new-supplier-form-edit.vue?vue&type=script&lang=js"
export * from "./new-supplier-form-edit.vue?vue&type=script&lang=js"
import style0 from "./new-supplier-form-edit.vue?vue&type=style&index=0&id=48e303da&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e303da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48e303da')) {
      api.createRecord('48e303da', component.options)
    } else {
      api.reload('48e303da', component.options)
    }
    module.hot.accept("./new-supplier-form-edit.vue?vue&type=template&id=48e303da&scoped=true", function () {
      api.rerender('48e303da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/edit-poppers/new-supplier-form-edit.vue"
export default component.exports